import {
  EnrolledStudentsTable,
  EnrolledStudentTableRow,
} from '@/components/table/EnrolledStudentsTable';
import { IEnrolmentPreviewPair } from '@/hooks/useGetEnrolmentPreview';
import { useLocale } from '@/providers/LocaleProvider';
import { useMemo } from 'react';
import { Dialog } from './Dialog';

interface Props {
  open: boolean;
  onClose: () => void;
  /** The enrolment preview's unchargeable pairs — the students already enrolled, per course. */
  pairs: IEnrolmentPreviewPair[];
}

export const EnrolledStudentsDialog = ({ open, onClose, pairs }: Props) => {
  const { translate } = useLocale();

  const rows = useMemo(
    () =>
      pairs.map<EnrolledStudentTableRow>((p) => ({
        employeeId: p.employeeId,
        courseId: p.courseId,
        student: p.studentName,
        course: p.courseTitle,
      })),
    [pairs]
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='md'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: { xs: '0', md: '16px' },
        },
      }}
      title={translate('manage.enrolStudentsPage.enrolledStudentsTitle')}
      closeButtonSx={{
        display: 'block',
      }}
      contentSx={{
        paddingBottom: { xs: '20px !important', md: '40px !important' },
      }}
    >
      <EnrolledStudentsTable
        rows={rows}
        translate={translate}
        sortable={false}
        selectable={false}
        paper={false}
        pagination={false}
        showFooter={false}
      />
    </Dialog>
  );
};
